<template>
	<div class="contract-list">
		<div class="table-wrap">
		  <div class="top-box">
			  <span>用户名：{{userInfo.username||''}}</span>
			  <span>角色：{{userInfo.roleNames||''}}</span>
			  <span>所属组织：{{userInfo.deptName||''}}</span>
		  </div>
		  <div class="list-box">
			  <div class="select-box">
				 <span style="display: block; margin: 10px 0;">作为业务负责人的商务合同：</span>
				 <div>
				   <el-checkbox-group v-model="tableData.contractList" style="width: 100%;overflow: hidden;">
					 <el-checkbox  v-for="(item,index) in htList" :key='index' :label="item.id" >{{item.name}}</el-checkbox>
				   </el-checkbox-group>
				 </div>
			  </div>
			  <div class="select-people">
				  <div style="margin-top: 30px;">业务负责人接收人：</div>
				  <el-input :value="tableData.name1">
				    <i slot="append" @click="selectBox(1)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				  </el-input>
			  </div>
		  </div>
		  <div class="list-box">
			  <div class="select-box">
				 <span style="display: block; margin: 10px 0;">作为有花果负责人的框架协议：</span>
				 <div>
				   <el-checkbox-group v-model="tableData.frameworkAgreementList">
					 <el-checkbox  v-for="(item,index) in htList2" :key='index' :label="item.id">{{item.name}}</el-checkbox>
				   </el-checkbox-group>
				 </div>
			  </div>
			  <div class="select-people">
				  <div style="margin-top: 30px;">有花果负责人接收人：</div>
				  <el-input :value="tableData.name2">
					<i slot="append" @click="selectBox(2)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				  </el-input>
			  </div>
		  </div>
		  <div class="list-box">
			  <div class="select-box">
				 <span style="display: block; margin: 10px 0;">作为项目负责人的品牌：</span>
				 <div>
				   <el-checkbox-group v-model="tableData.brandList">
					 <el-checkbox  v-for="(item,index) in htList3" :key='index' :label="item.id">{{item.name}}</el-checkbox>
				   </el-checkbox-group>
				 </div>
			  </div>
			  <div class="select-people">
				  <div style="margin-top: 30px;">项目负责人接收人：</div>
				  <el-input :value="tableData.name3">
					<i slot="append" @click="selectBox(3)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				  </el-input>
			  </div>
		  </div>
		  <div class="list-box">
			  <div class="select-box">
				 <span style="display: block; margin: 10px 0;">作为合同负责人的品牌合同：</span>
				 <div>
				   <el-checkbox-group v-model="tableData.brandContractList">
					 <el-checkbox  v-for="(item,index) in htList4" :key='index' :label="item.id">{{item.name}}</el-checkbox>
				   </el-checkbox-group>
				 </div>
			  </div>
			  <div class="select-people">
				  <div style="margin-top: 30px;">合同负责人接收人：</div>
				  <el-input :value="tableData.name4">
					<i slot="append" @click="selectBox(4)"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				  </el-input>
			  </div>
		  </div>
		  <div style="margin-top: 20px;">Tips：工作交接提交成功需要较长时间，请在提交成功后再关闭页面。</div>
		  <div style="text-align:center;margin-top: 25px;" >
		   <el-button style="width:120px;" @click="saveClick('ruleForm')" type="primary">提交</el-button>
		  </div>
		  <!-- //盖章经办人弹框 -->
		  <sealPeople ref="sealp" @select="selectPeople"></sealPeople>
		</div>
	</div>
</template>

<script>
	import sealPeople from "@/components/common/sealPeople";//引入选择盖章经办人
	import * as qiniu from "qiniu-js"; 
	import { qiniuToken } from "@/api/index";
	import XLSX from "xlsx";
	import {
		mapGetters
	} from "vuex";
	import validate from "@/util/validate";
	import util from "@/util/util";
	import {
		contractConfig
	} from "@/const/config/contract";
	import InvoiceFormFields from "@/const/form/InvoiceForm";
	import {
		billingConfig
	} from "@/const/config/billing";
	import {
		dataList,lzComit
	} from "./index.js";
	import {
		processList
	} from "@/api/approve/contract";
	import approveList from "@/components/common/approveMember";
	export default {
		components: {
			sealPeople,
		},
		data() {
			return {
				peopleType:null,//1业务负责人接收人2业务负责人接收人3项目负责人接收人4合同负责人接收人
				userInfo:{},//用户信息
				name:'',
				checkList:[1],//商务合同列表
				checkList2:[1],//框架协议列表
				checkList3:[1],//品牌列表
				htList:[],//商务合同列表
				htList2:[],//框架协议列表
				htList3:[],//品牌列表
				htList4:[],//品牌合同列表
				tableData:{
					name1:'',
					name2:'',
					name3:'',
					name4:'',
					brandContractList:[],//品牌合同ids
					brandContractReceiveId:'',//品牌合同接收人id
					brandList:[],//品牌ids
					brandReceiveId:'',//品牌接收人id
					contractList:[],//商务合同ids
					contractReceiveId:'',//商务合同接收人id
					frameworkAgreementList:[],//框架协议ids
					frameworkAgreementReceiveId:'',//框架协议接收人id
				},
				contractConfig: contractConfig,
				tableLoading: false,
			};
		},
		mounted() {
		 this.userInfo = JSON.parse(sessionStorage.getItem('youhuaguo-user')).content 
		 console.log(this.userInfo)
		 this.getList();
		},
		computed: {
			...mapGetters(["permissions", "dicts"]),
		},
		methods: {
			//打开选择人弹框
			selectBox(number){
				this.peopleType = number
				this.$refs.sealp.title = '选择接收人'
				this.$refs.sealp.adminListModal=true
			},
			//选择经办人
			selectPeople(row){
				console.log(this.peopleType)
				console.log(row)
				if(this.peopleType==1){
					this.tableData.contractReceiveId = row.id
					this.tableData.name1 = row.username
				}else if(this.peopleType==2){
					this.tableData.frameworkAgreementReceiveId = row.id
					this.tableData.name2 = row.username
				}else if(this.peopleType==3){
					this.tableData.brandReceiveId = row.id
					this.tableData.name3 = row.username
				}else if(this.peopleType==4){
					this.tableData.brandContractReceiveId = row.id
					this.tableData.name4 = row.username
				}
			},
			//提交
			saveClick() {
				console.log(this.tableData)
				if(this.userInfo.id == this.tableData.brandContractReceiveId ||
				 this.userInfo.id == this.tableData.brandReceiveId ||
				 this.userInfo.id == this.tableData.contractReceiveId ||
				 this.userInfo.id == this.tableData.frameworkAgreementReceiveId
				 ){
					 this.$message({
					   message: '接收人不能选择自己',
					   type: 'warning'
					 });
					 return
				 }
				lzComit(this.tableData).then((res) => {
					if (res.code == 1) {
						this.$message.success("提交成功！");
						this.getList();
					}
				});
			},
			// 获取列表
			getList() {
			  const obj = {
				  userId : this.userInfo.id
			  }
			  dataList(obj)
				.then((res) => {
					this.htList = res.data.contractList
					this.htList2 = res.data.frameworkAgreementList
					this.htList3 = res.data.brandList
					this.htList4 = res.data.brandContractList
					this.$forceUpdate()
				})
				.catch((err) => {
					
				});
			},
		},

	};
</script>

<style lang="scss" scoped>
	.select-box{
		 width: 70%;
	}
	.top-box{
		display: flex;
		justify-content: space-around;
	}
	.list-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #e3e3e3;
		padding: 10px;
		border-radius: 10px;
		margin-top: 10px;
	}
	//蓝色选择图标
	.el-input-group__append {
	  position: relative;
	  width: 32px;
	  height: 32px;
	  border: none;
	  background: #fff;
	  padding: 0;
	  color: #409eff !important;
	  .iconfont {
	    position: absolute;
	    top: 0;
	    left: 0;
		  right: 0;
		  bottom: 0;
		  margin: auto;
	    font-size: 33px !important;
		   color: #409eff !important;
		   margin: 0 auto !important;
		   text-align: center !important;
	  }
	  cursor: pointer;
	}
	
	
	
	
	.dz-img {
		display: block;
		width: 90px;
		height: 100px;
		margin: 0 auto;
	}

	.dz-title {
		font-size: 30px;
		color: #000;
		font-weight: bold;
		text-align: center;
		padding: 10px;
	}

	.dz-text {
		text-align: center;
		padding: 20px;
	}

	.dz-info {
		display: flex;
		justify-content: space-around;
		padding: 20px;
	}


	.mar-c {
		display: flex;
		justify-content: center;
	}

	.table-count {
		margin: 15px 0 10px;
	}

	// 列表item
	.block-form-item {
		&.w-32 {
			display: inline-block;
			width: 32%;
			margin-right: 1%;
			height: 64px;
		}

		&.w-99 {
			width: 99%;
			margin-right: 1%;
		}
	}

	.yhg-dialog {
		.select-con {
			display: flex;

			.label {
				white-space: nowrap;
			}

			.select-tag {
				margin-right: 5px;
				margin-bottom: 5px;
			}

			.select-tag-text {
				display: inline-block;
				max-width: 86px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.filter-con {
			display: flex;
			align-items: center;
			margin: 20px 0;
			width: 800px;

			.label {
				white-space: nowrap;
			}

			.search-btn {
				margin-left: 15px;
			}
		}

		.submit-con {
			margin-top: 20px;
			text-align: right;
		}
	}

	.select-input-wrap-s {
		.el-input-group__append {
			position: relative;
			width: 32px;
			height: 32px;
			border: none;
			background: #fff;
			padding: 0;
			color: #409eff;

			.iconfont {
				position: absolute;
				top: -2px;
				left: -1px;
				font-size: 33px !important;
			}

			cursor: pointer;
		}
	}

	.select-con {
		.el-tag .el-icon-close {
			top: -8px;
		}
	}

	.avue-view .cost-table {
		width: calc(50% + 100px);

		th {
			background: none;
			font-weight: normal;
			font-size: 14px;
		}

		.cell {
			padding-left: 0;
		}
	}

	.el-table .operate-column {
		vertical-align: text-top;
	}

	/deep/.el-dialog__header {
		border-bottom: 1px solid #ccc !important;
	}

	.invoiceList {
		display: flex;
		justify-content: space-between;
	}

	.mt-10 {
		margin-top: 10px;
	}
</style>
<style>
	.el-dialog {
	    width: 70%;
	}
	.el-icon-delete-solid:hover{
		color: #66B1FF;
	}
	.el-icon-delete-solid{
		cursor: pointer;
	}
	.el-checkbox+.el-checkbox {
		margin-left: 0px;
		margin-top: 10px;
	}
</style>
